import {
  Box,
  Button,
  Card,
  Divider,
  FormControlLabel,
  Grid,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface TypeOption {
  title: string;
  value: string;
}

const typeOptions: TypeOption[] = [
  {
    title: 'Yes',
    value: 'true',
  },
  {
    title: 'No',
    value: 'false',
  },
];

const MedicalDetails = ({ title }: any) => {
  const [open, setOpen] = useState(false);
  const icon = open ? <ExpandLessIcon /> : <ExpandMoreIcon />;
  return (
    <>
      <Stack>
        <Button
          onClick={(event) => setOpen((prev) => !prev)}
          endIcon={icon}
          sx={{
            padding: '0 1.5rem',
            height: '40px',
            borderRadius: '0px',
            justifyContent: 'space-between',
            color: 'black',
          }}
        >
          <Typography variant="h6">{title}</Typography>
        </Button>
        <Divider />
      </Stack>
      {open && (
        <Grid
          container
          spacing={3}
          sx={{ padding: '0 1.5rem' }}
        >
          <Grid
            item
            xs={6}
          >
            <Stack gap=".5rem">
              <Typography>Medical & Emergency</Typography>
              <Stack
                component={RadioGroup}
                spacing={5}
                rowGap={4}
              >
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  {typeOptions.map((option, index) => {
                    return (
                      <FormControlLabel
                        control={<Radio />}
                        key={option.value}
                        label={
                          <Box>
                            <Typography variant="subtitle2">{option.title}</Typography>
                          </Box>
                        }
                        value={option.value}
                      />
                    );
                  })}
                </RadioGroup>
              </Stack>
              <OutlinedInput
                fullWidth
                multiline
                placeholder="Add a Comment"
                rows={1}
              />
            </Stack>
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Stack gap=".5rem">
              <Typography>Pain Affecting Daily Routine</Typography>
              <Stack
                component={RadioGroup}
                spacing={5}
                rowGap={4}
              >
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  {typeOptions.map((option, index) => {
                    return (
                      <FormControlLabel
                        control={<Radio />}
                        key={option.value}
                        label={
                          <Box>
                            <Typography variant="subtitle2">{option.title}</Typography>
                          </Box>
                        }
                        value={option.value}
                      />
                    );
                  })}
                </RadioGroup>
              </Stack>
              <OutlinedInput
                fullWidth
                multiline
                placeholder="Add a comment"
                rows={1}
              />
            </Stack>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default MedicalDetails;
